/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const Stack1IconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M1.2 8.4c0-3.394 0-5.091 1.054-6.146C3.31 1.2 5.006 1.2 8.4 1.2H12c3.394 0 5.091 0 6.146 1.054.601.602.86 1.413.97 2.63 1.217.11 2.028.369 2.63.97C22.8 6.91 22.8 8.606 22.8 12v3.6c0 3.394 0 5.091-1.054 6.146C20.69 22.8 18.994 22.8 15.6 22.8H12c-3.394 0-5.091 0-6.146-1.054-.601-.602-.86-1.413-.97-2.63-1.217-.11-2.028-.369-2.63-.97C1.2 17.09 1.2 15.394 1.2 12V8.4zm7.2-4.8H12c1.765 0 2.847.005 3.63.11.689.093.804.225.817.24l.002.001v.002c.016.013.148.128.24.817.106.783.111 1.865.111 3.63V12c0 1.765-.005 2.847-.11 3.63-.093.689-.225.804-.24.817l-.001.002h-.002c-.013.016-.128.148-.817.24-.783.106-1.865.111-3.63.111H8.4c-1.765 0-2.847-.005-3.63-.11-.689-.093-.804-.225-.817-.24l-.002-.001v-.002c-.016-.013-.148-.128-.24-.817-.106-.783-.111-1.865-.111-3.63V8.4c0-1.765.005-2.847.11-3.63.093-.689.225-.804.24-.817l.001-.002h.002c.013-.016.128-.148.817-.24.783-.106 1.865-.111 3.63-.111zM7.306 19.198l.004.032c.093.689.225.804.24.817l.001.002h.002c.013.016.128.148.817.24.783.106 1.865.111 3.63.111h3.6c1.765 0 2.847-.005 3.63-.11.689-.093.804-.225.817-.24l.002-.001v-.002c.016-.013.148-.128.24-.817.106-.783.111-1.865.111-3.63V12c0-1.765-.005-2.847-.11-3.63-.093-.689-.225-.804-.24-.817l-.001-.002h-.002c-.013-.016-.128-.148-.817-.24a6.72 6.72 0 00-.032-.005c.002.344.002.708.002 1.094V12c0 3.394 0 5.091-1.054 6.146C17.09 19.2 15.394 19.2 12 19.2H8.4c-.386 0-.75 0-1.094-.002z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
Stack1IconSvg.displayName = 'Stack1IconSvg'

const Stack1Icon = forwardRef((props, ref) => <Icon component={Stack1IconSvg} ref={ref} {...props} />)
Stack1Icon.displayName = 'Stack1Icon'

Stack1Icon.defaultProps = {
	...Icon.defaultProps,
}
Stack1Icon.propTypes = {
	...Icon.propTypes,
}

export default Stack1Icon
export { Stack1IconSvg }
